import { buildNonMonetaryDetailSheet, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Punishment";

export function buildPunishmentSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildNonMonetaryDetailSheet(
    workbook,
    SHEET_NAME,
    "Details of punishment",
    toRows(essential?.nonMonetary?.punishment)
  );
}
